import "./load-more.scss"
import { PageState, PageComponent } from "barba"

class LoadMore {
    constructor({ node }) {
        this.node = node
        this.id = this.node.id || null
        this.increment = this.node.dataset.loadMore ? parseInt(this.node.dataset.loadMore) : 9999
        this.items = this.node.querySelectorAll('[data-load-more-item]')
        this.btn = this.node.querySelector('[data-load-more-btn]')

        if (!this.btn || this.items.length <= 0) return

        this.btnCollapse = this.node.querySelector('[data-load-more-btn-collapse]')
        this.counter = this.id ? PageState.get(`load-more-counter-${this.id}`) || 0 : 0
        
        this.loadHandler = this.load.bind(this)
        this.updateHandler = this.update.bind(this)
        
        this.btn.addEventListener("click", this.loadHandler)
        window.addEventListener("resize", this.updateHandler)
        
        this.update()
    }

    load() {
        this.counter = this.counter + this.increment
        this.update()
        this.updatePageState()
    }

    update() {
        // Read scroll height in batch
        let btnCollapseMaxHeight = this.counter < this.items.length ? this.btnCollapse.scrollHeight : 0
        let itemsMaxHeight = []
        for (let i = 0; i < this.items.length; i++) {
            itemsMaxHeight[i] = 0
            if (i < this.counter) {
                itemsMaxHeight[i] = this.items[i].scrollHeight
            }
        }
        // Write in batch
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].style.setProperty('--load-more-max-height', `${itemsMaxHeight[i] || (i < this.counter ? 9999 : 0)}px`)
        }
        this.btnCollapse.style.setProperty('--load-more-max-height', `${btnCollapseMaxHeight}px`)
    }

    updatePageState() {
        if (this.id) {
            PageState.set(`load-more-counter-${this.id}`, this.counter)
        }
    }

    destroy() {
        !this.btn || this.btn.removeEventListener("click", this.loadHandler)
        window.removeEventListener("resize", this.updateHandler)

        delete this.loadHandler
        delete this.updateHandler

        delete this.node
        delete this.id
        delete this.increment
        delete this.items
        delete this.btn
        delete this.btnCollapse
        delete this.counter
    }
}

new PageComponent("[data-load-more]", LoadMore)
